export const CHECKOUT_URL = 'https://alignercase-en.impultienda.ar/checkout/'

export const GUARANTEE_LINE = 'One-time payment · Lifetime access · 7-day guarantee'
